import { MDCTextField } from '@material/textfield';
import { MDCSelect } from '@material/select';
import { MDCTabBar } from '@material/tab-bar';
import { MDCFormField } from '@material/form-field';
import { MDCCheckbox } from '@material/checkbox';
import {MDCRadio} from '@material/radio';

//  mdc field aply float label
let textFieldFloat = [...document.querySelectorAll('.mdc-text-field')];
if (textFieldFloat) {
    for (const element of textFieldFloat) {
        new MDCTextField(element);
    }
}

const select = [...document.querySelectorAll('.mdc-select-ini')];
if (select) {
    for (const element of select) {
        const select = new MDCSelect(element)
        select.listen('MDCSelect:change', () => {
            let valueSlct = document.querySelectorAll('.mdc-select__selected-text');
            let idSelect = select.root.id;
            //getComunas(select.value);
            switch (idSelect) {
                case 'mdc-select-region':                
                    getComunas(select.value);                
                    $('#region_e').val(select.value);
                    break;
                case 'select-num':   
                    $('#dnum_workers').val(select.value);
                    break;
                case 'select-cargo':
                    $('#dcargo').val(select.value);
                    break;
                case 'select-num-company':   
                    $('#dnum_workers-company').val(select.value);
                    break;
                case 'select-cargo-company':
                    $('#dcargo-company').val(select.value);
                    break;
                default:
                    //console.log('');
              }
            let listOption = [...document.querySelectorAll('.mdc-list-item')];
            let mcValue = '';
            for (const key in listOption) {
                if (Object.hasOwnProperty.call(listOption, key)) {
                    const element = listOption[key];
                    if (parseInt(key) === select.selectedIndex) {
                        mcValue = element.dataset.mc;
                    }
                    
                }
            }
            for (const element of valueSlct) {
                let id = element.dataset.id;
                    /* elementInput = document.querySelector(`#${id}`);
                    elementInput.value = select.value;
                    elementInput.dataset.mdc_value = mcValue; */
    
                // remove validate
                element.parentNode.parentNode.classList.remove('mdc-text-field--invalid');
            }
        });;
    
    }
}

if (document.querySelector('.mdc-checkbox') && document.querySelector('.mdc-form-field')) {
    const checkbox = new MDCCheckbox(document.querySelector('.mdc-checkbox'));
    const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
    formField.input = checkbox;
    
}
if (document.querySelector('.mdc-radio') && document.querySelector('.mdc-form-field')) {
    const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
    const radio = new MDCRadio(document.querySelector('.mdc-radio'));
    formField.input = radio;
}

const tabsBar = document.querySelector('.mdc-tab-bar');
if (tabsBar) {

    const tabBar = new MDCTabBar(tabsBar);
    const contentEls = [...document.querySelectorAll('.av-tab-content')];
    if (contentEls) {

        tabBar.listen('MDCTabBar:activated', function (event) {
            let indexContent = 0;
            for (const key in contentEls) {
                if (Object.hasOwnProperty.call(contentEls, key)) {
                    const contentTab = contentEls[key];
                    let index = parseInt(key);
                    
                    if (index < event.detail.index) contentTab.classList.remove('av-tab-content--active');
                    if (index < event.detail.index) contentTab.classList.add('av-tab-content--disabled');

                    if (index > event.detail.index) contentTab.classList.remove('av-tab-content--active');
                    if (index > event.detail.index) contentTab.classList.remove('av-tab-content--disabled');

                    if (index === event.detail.index) contentTab.classList.add('av-tab-content--active');

                    // content tab select
                    let tabContentID = document.querySelectorAll('.mdc-tab')[event.detail.index].dataset.tab.split('#')[1];
                    //let contenTabs = (window.width <= 991) ? document.querySelectorAll('section[data-device_media="mobile"]') : document.querySelectorAll('section[data-device_media="mobile"]');
                    let contenTabs = [...document.querySelectorAll('section[data-tab_id]')];
                    let contentTabSelect = contenTabs.filter(element => element.dataset.tab_id === tabContentID);
                    let contentTabDontSelect = contenTabs.filter(element => element.dataset.tab_id !== tabContentID);
                    if (contentTabSelect) {
                        for (const contentSelect of contentTabSelect) {
                            contentSelect.style = '';
                        }
                    }
                    if (contentTabDontSelect) {
                        for (const contentDontSelect of contentTabDontSelect) {
                            contentDontSelect.setAttribute('style', 'display:none !important;');
                        }
                    }
                }
            }
           /*  for (const content of contentEls) {
                if (content.classList.contains('av-tab-content--active') === true) {
                    if (event.detail.index > indexContent) content.classList.add('av-tab-content--disabled');
                    if (event.detail.index > indexContent) content.classList.remove('av-tab-content--active');

                    if (event.detail.index < indexContent) content.classList.remove('av-tab-content--disabled');
                    if (event.detail.index < indexContent) content.classList.remove('av-tab-content--active');

                    contentEls[event.detail.index].classList.add('av-tab-content--active')
                }
                indexContent++;
            } */
        });

    }

}



const regiones = 
    [{
        "region": "Región de Arica y Parinacota",
        "comunas": ["Arica", "Camarones", "Putre", "General Lagos"]
    },
    {
        "region": "Región de Tarapacá",
        "comunas": ["Iquique", "Alto Hospicio", "Pozo Almonte", "Camiña", "Colchane", "Huara", "Pica"]
    },
    {
        "region": "Región de Antofagasta",
        "comunas": ["Antofagasta", "Mejillones", "Sierra Gorda", "Taltal", "Calama", "Ollagüe", "San Pedro de Atacama", "Tocopilla", "María Elena"]
    },
    {
        "region": "Región de Atacama",
        "comunas": ["Copiapó", "Caldera", "Tierra Amarilla", "Chañaral", "Diego de Almagro", "Vallenar", "Alto del Carmen", "Freirina", "Huasco"]
    },
    {
        "region": "Región de Coquimbo",
        "comunas": ["La Serena", "Coquimbo", "Andacollo", "La Higuera", "Paiguano", "Vicuña", "Illapel", "Canela", "Los Vilos", "Salamanca", "Ovalle", "Combarbalá", "Monte Patria", "Punitaqui", "Río Hurtado"]
    },
    {
        "region": "Región de Valparaíso",
        "comunas": ["Valparaíso", "Casablanca", "Concón", "Juan Fernández", "Puchuncaví", "Quintero", "Viña del Mar", "Isla de Pascua", "Los Andes", "Calle Larga", "Rinconada", "San Esteban", "La Ligua", "Cabildo", "Papudo", "Petorca", "Zapallar", "Quillota", "Calera", "Hijuelas", "La Cruz", "Nogales", "San Antonio", "Algarrobo", "Cartagena", "El Quisco", "El Tabo", "Santo Domingo", "San Felipe", "Catemu", "Llaillay", "Panquehue", "Putaendo", "Santa María", "Quilpué", "Limache", "Olmué", "Villa Alemana"]
    },
    {
        "region": "Región del Libertador General Bernardo O’Higgins",
        "comunas": ["Rancagua", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "Las Cabras", "Machalí", "Malloa", "Mostazal", "Olivar", "Peumo", "Pichidegua", "Quinta de Tilcoco", "Rengo", "Requínoa", "San Vicente", "Pichilemu", "La Estrella", "Litueche", "Marchihue", "Navidad", "Paredones", "San Fernando", "Chépica", "Chimbarongo", "Lolol", "Nancagua", "Palmilla", "Peralillo", "Placilla", "Pumanque", "Santa Cruz"]
    },
    {
        "region": "Región del Maule",
        "comunas": ["Talca", "Constitución", "Curepto", "Empedrado", "Maule", "Pelarco", "Pencahue", "Río Claro", "San Clemente", "San Rafael", "Cauquenes", "Chanco", "Pelluhue", "Curicó", "Hualañé", "Licantén", "Molina", "Rauco", "Romeral", "Sagrada Familia", "Teno", "Vichuquén", "Linares", "Colbún", "Longaví", "Parral", "Retiro", "San Javier", "Villa Alegre", "Yerbas Buenas"]
    },
    {
        "region": "Región del Ñuble",
        "comunas": ["Cobquecura", "Coelemu", "Ninhue", "Portezuelo", "Quirihue", "Ránquil", "Treguaco", "Bulnes", "Chillán Viejo", "Chillán", "El Carmen", "Pemuco", "Pinto", "Quillón", "San Ignacio", "Yungay", "Coihueco", "Ñiquén", "San Carlos", "San Fabián", "San Nicolás"]
    },
    {
        "region": "Región del Biobío",
        "comunas": ["Concepción", "Coronel", "Chiguayante", "Florida", "Hualqui", "Lota", "Penco", "San Pedro de la Paz", "Santa Juana", "Talcahuano", "Tomé", "Hualpén", "Lebu", "Arauco", "Cañete", "Contulmo", "Curanilahue", "Los Álamos", "Tirúa", "Los Ángeles", "Antuco", "Cabrero", "Laja", "Mulchén", "Nacimiento", "Negrete", "Quilaco", "Quilleco", "San Rosendo", "Santa Bárbara", "Tucapel", "Yumbel", "Alto Biobío"]
    },
    {
        "region": "Región de La Araucanía",
        "comunas": ["Temuco", "Carahue", "Cunco", "Curarrehue", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Melipeuco", "Nueva Imperial", "Padre las Casas", "Perquenco", "Pitrufquén", "Pucón", "Saavedra", "Teodoro Schmidt", "Toltén", "Vilcún", "Villarrica", "Cholchol", "Angol", "Collipulli", "Curacautín", "Ercilla", "Lonquimay", "Los Sauces", "Lumaco", "Purén", "Renaico", "Traiguén", "Victoria"]
    },
    {
        "region": "Región de Los Ríos",
        "comunas": ["Valdivia", "Corral", "Lanco", "Los Lagos", "Máfil", "Mariquina", "Paillaco", "Panguipulli", "La Unión", "Futrono", "Lago Ranco", "Río Bueno"]
    },
    {
        "region": "Región de Los Lagos",
        "comunas": ["Puerto Montt", "Calbuco", "Cochamó", "Fresia", "Frutillar", "Los Muermos", "Llanquihue", "Maullín", "Puerto Varas", "Castro", "Ancud", "Chonchi", "Curaco de Vélez", "Dalcahue", "Puqueldón", "Queilén", "Quellón", "Quemchi", "Quinchao", "Osorno", "Puerto Octay", "Purranque", "Puyehue", "Río Negro", "San Juan de la Costa", "San Pablo", "Chaitén", "Futaleufú", "Hualaihué", "Palena"]
    },
    {
        "region": "Región de Aysén del General Carlos Ibáñez del Campo",
        "comunas": ["Coihaique", "Lago Verde", "Aisén", "Cisnes", "Guaitecas", "Cochrane", "O’Higgins", "Tortel", "Chile Chico", "Río Ibáñez"]
    },
    {
        "region": "Región de Magallanes y la Antártica Chilena",
        "comunas": ["Punta Arenas", "Laguna Blanca", "Río Verde", "San Gregorio", "Cabo de Hornos (Ex Navarino)", "Antártica", "Porvenir", "Primavera", "Timaukel", "Natales", "Torres del Paine"]
    },
    {
        "region": "Región Metropolitana de Santiago",
        "comunas": ["Cerrillos", "Cerro Navia", "Conchalí", "El Bosque", "Estación Central", "Huechuraba", "Independencia", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "Ñuñoa", "Pedro Aguirre Cerda", "Peñalolén", "Providencia", "Pudahuel", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "Santiago", "San Joaquín", "San Miguel", "San Ramón", "Vitacura", "Puente Alto", "Pirque", "San José de Maipo", "Colina", "Lampa", "Tiltil", "San Bernardo", "Buin", "Calera de Tango", "Paine", "Melipilla", "Alhué", "Curacaví", "María Pinto", "San Pedro", "Talagante", "El Monte", "Isla de Maipo", "Padre Hurtado", "Peñaflor"]
        }]
   ;
   let selectComuna
   let elementComuna
       
   function getComunas(com) {
    let region = regiones.find((item) => {
        //console.log(item.region)
        if(item.region == com){
            return item;
        }
    
    } )
    let {comunas} = region
    let li = ``
    comunas.map((item) => {

        li += `<li class="mdc-list-item" aria-selected="false" data-value="${item}" role="option">
        <span class="mdc-list-item__ripple"></span>
        <span class="mdc-list-item__text">
            ${item}
        </span>
    </li>`


    })

    let listComunas = document.querySelectorAll('.mdc-list.list-comunas')[0]
        listComunas.innerHTML = li
        elementComuna = null
        selectComuna = null
        elementComuna = document.getElementById('select-comuna')
        selectComuna = new MDCSelect(elementComuna)

        selectComuna.listen('MDCSelect:change', () => {
            
        $('#comuna_e').val(selectComuna.value);
    } )
}